import Axios from '@/util/Axios'
import qs from 'qs';

export default {
  state:{
    loading:{
      flag:false,
      text:'',
    },
    cfg: {
      apps_options:[],
      order_status:[],
      font_options:[],
    },
    user: {
      uid:0,
    },
  },
  mutations:{
    setLoading(state,n){
      if (n.text) {
        state.loading.flag = true;
        state.loading.text = n.text;
      } else {
        state.loading.flag = false;
      }
    },
    setCfgOptions(state, data) {
        state.cfg = data;
        if (data.font_options) {
            const styleId = 'casedraw-dynamic-fonts';
            let styleTag = document.getElementById(styleId);
            if (!styleTag) {
                styleTag = document.createElement('style');
                styleTag.id = styleId;
                document.head.appendChild(styleTag);
            }

            let cssRules = '';
            data.font_options.forEach(font => {
                cssRules += `
                    @font-face {
                        font-family: '${font.font_name}';
                        src: url('${font.font_path}') format('truetype');
                        font-display: swap; 
                    }
                `;
            });
            styleTag.textContent = cssRules;
        }
    },
    set_sign_user(state, n) { 
      var uid = localStorage.getItem("uid")
      state.user = new Object()
      state.user.uid = uid;
    },
  },
  actions:{
    getCfgOptions(context){
      Axios.post('/v1/pub/helpers/cfg-options', {})
        .then(function (response) {
          var res = response.data;
          if (res.code == 1) {
            context.commit('setCfgOptions', res.data);
          }
        })
    },
  }


}



// WEBPACK FOOTER //
// ./src/vuex/modules/public/index.js